"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check

var _factory = require("./factory");

var _factory2 = _interopRequireDefault(_factory);

var _translator = require("../../translator");

var _translator2 = _interopRequireDefault(_translator);

var _refundExchangeAdapter = require("../refund-exchange-adapter");

var _selectPertinentPolicies = require("../select-pertinent-policies");

var _selectPertinentPolicies2 = _interopRequireDefault(_selectPertinentPolicies);

var _tagger = require("../tagger");

var _tagger2 = _interopRequireDefault(_tagger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExchangePolicies = function () {
  function ExchangePolicies(_ref) {
    var phrases = _ref.phrases,
        locale = _ref.locale;

    _classCallCheck(this, ExchangePolicies);

    this.translator = /** @type {Translator.Service} */new _translator2.default(phrases);
    this.locale = locale;
  }

  /**
   * @param {V2.Departure} departure
   * @param {V2.Options?} options
   */


  _createClass(ExchangePolicies, [{
    key: "pertinent",
    value: function pertinent(departure, options) {
      var _this = this;

      var standardized_terms = (0, _refundExchangeAdapter.standardizeExchangesInput)(departure.terms);

      var _selectPertinentData = (0, _selectPertinentPolicies2.default)(standardized_terms),
          has_actionable_policies = _selectPertinentData.has_actionable_policies,
          pertinent_policies = _selectPertinentData.policies;

      var grouped_terms = (0, _refundExchangeAdapter.groupAdjacentPolicyTypes)(pertinent_policies);

      var formatted_terms = grouped_terms.map(function (data) {
        return (0, _factory2.default)(data, _this.locale);
      });

      var output = {
        is_exchangeable: has_actionable_policies,
        policies: this.translator.translateAll(formatted_terms)
      };

      return options && options.utm_tags ? (0, _tagger2.default)(options.utm_tags, output) : output;
    }
  }]);

  return ExchangePolicies;
}();

exports.default = ExchangePolicies;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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